export enum ChatType {
  SUPPLIER = "supplier",
  CUSTOMER = "customer",
}

export enum ParticipantType {
  ORDER_HANDLER= "orderHandler",
  SUPPLIER= "supplier",
  CUSTOMER = "customer",
}

export const isChatType = (value: string): value is ChatType => {
  return Object.values(ChatType).includes(value as ChatType);
};

export const getChatTypeLabel = (chatType: ChatType): string => {
  switch (chatType) {
    case ChatType.SUPPLIER:
      return "Suppliers";
    case ChatType.CUSTOMER:
      return "Customers";
    default:
      return "Unknown";
  }
};

export const getChatTypeIcon = (chatType: ChatType): string => {
  switch (chatType) {
    case ChatType.SUPPLIER:
      return "🏪";
    case ChatType.CUSTOMER:
      return "👤";
    default:
      return "❓";
  }
};
